import get from 'just-safe-get';

import featureTests from './feature-tests';

export default function hasFeature(feature) {
  return get(featureTests, feature);
}
